import { Injectable } from '@angular/core';
import { Paging } from '../model/node/paging';

@Injectable({
    providedIn: 'root'
})
export class PagingService {
    public paging: Paging = new Paging();
    constructor() {}
}
